import { Box, TextField } from '@mui/material';
import { IntegrationAgentsNameSelector } from 'TenantModule/components/Management/IntegrationAgentsNameSelector';
import { FC, ChangeEvent } from 'react';
import { StyledDefaultPrimaryButton } from 'styles';

export const IntegrationSecretsSection: FC<{
  isDisabled: boolean;
  sectionId: string;
  integrationAgentName: string;
  integrationAgentsOverride?: { value: string; name: string; disabled?: boolean }[];
  secret: string;
  removeRow: (sectionId: string) => void;
  onChange: (e: ChangeEvent<any>) => void;
}> = ({
  isDisabled,
  sectionId,
  integrationAgentName,
  secret,
  removeRow,
  onChange,
  integrationAgentsOverride,
}) => {
  const onRemove = () => {
    removeRow(sectionId);
  };

  return (
    <Box
      key={sectionId}
      sx={{
        display: 'flex',
        gap: '20px',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '40%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <IntegrationAgentsNameSelector
          value={integrationAgentName}
          onChange={onChange}
          disabled={isDisabled}
          itemsOverride={integrationAgentsOverride}
        />
      </Box>
      <Box
        sx={{
          width: '40%',
        }}
      >
        <TextField
          onChange={onChange}
          value={secret}
          label="Secret"
          name="secret"
          type="text"
          variant="outlined"
          fullWidth
          disabled={isDisabled}
        />
      </Box>
      <Box
        sx={{
          width: '20%',
        }}
      >
        <StyledDefaultPrimaryButton onClick={onRemove}>Remove</StyledDefaultPrimaryButton>
      </Box>
    </Box>
  );
};
